import {
  calculateColumnWidth,
  mapColumnTypes,
  selectColumnFactory,
  TYPES,
} from "@/react/components/table";
import { getColumnDef } from "@/react/schema/schemaFields";
import schema from "./schema";
import { DIAL_PLAN_RULE_SETS } from "./constants";

const columnDefinition = () =>
  calculateColumnWidth(
    [
      selectColumnFactory(),
      {
        ...getColumnDef(schema.fields.subscriptionId, "Subscription ID"),
        type: TYPES.ID,
      },
      {
        ...getColumnDef(schema.fields.extensionNumber, "Extension"),
        type: TYPES.STRING,
      },
      {
        ...getColumnDef(schema.fields.callerIdFirstName, "First Name"),
        type: TYPES.STRING,
      },
      {
        ...getColumnDef(schema.fields.callerIdLastName, "Last Name"),
        type: TYPES.STRING,
      },
      {
        ...getColumnDef(schema.fields.dialPlanRuleSetName, "Dialplan"),
        options: Object.fromEntries(
          DIAL_PLAN_RULE_SETS.map((dialplan) => [dialplan, dialplan])
        ),
        type: TYPES.SELECT,
        editable: true,
      },
    ].map(mapColumnTypes)
  );

export default columnDefinition;
